<template>
  <div class="page-grade-post" v-if="ready">
    <router-view />
  </div>
</template>
<script>
import './index.less';

export default {
  name: 'CertificatePost',
  data() {
    return {
      ready: false
    };
  },
  async created() {
    await this.guardAccess();
  },
  methods: {
    /**
     * @function guardAccess
     * @desc 检查峰会证书补寄开放时间
     */
    async guardAccess() {
      this.$loading.show();
      try {
        const sendReplacementOpen = await this.$ddl.isOver('峰会证书补寄开放');
        if (!sendReplacementOpen) {
          this.$message.error('暂未开放');
          this.$redirectToMyHsylc();
          return;
        }
        this.ready = true;
      } finally {
        this.$loading.hide();
      }
    }
  }
};
</script>
